/** @format */

import { supportUrl } from "../Config/Url";
import axios from "axios";

export const supportService = {
  getAll,
  create,
  update,
  remove,
  statistics,
  likesStatistics,
  commentsStatistics,
  latestComments,
};

async function getAll(languageId) {
  return axios
    .put(`${supportUrl}/search`, { pageIndex: 0, pageSize: 100, languageId })
    .then((res) => res)
    .catch((err) => err.response);
}

async function create(data) {
  return axios
    .post(`${supportUrl}`, data)
    .then((res) => res)
    .catch((err) => err.response);
}

async function update(id, data) {
 console.log("update data", data);
  return axios
    .put(`${supportUrl}/${id}`, data)
    .then((res) => res)
    .catch((err) => err.response);
}

async function remove(id) {
  return axios
    .delete(`${supportUrl}/${id}`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function statistics(minTimeSpent) {
  return axios
    .get(`${supportUrl}/statistics`, { params: { minTimeSpent } })
    .then((res) => res)
    .catch((err) => err.response);
}

async function likesStatistics() {
  return axios
    .get(`${supportUrl}/statistics/likes`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function commentsStatistics() {
  return axios
    .get(`${supportUrl}/statistics/comments`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function latestComments() {
  return axios
    .get(`${supportUrl}/statistics/comments/latest`)
    .then((res) => res)
    .catch((err) => err.response);
}
